// extracted by mini-css-extract-plugin
export default {"parent":"__parent__U0Hyz","description":"__description__SXO7s","image":"__image__lPpyB"};